export const PREVIEW_SETTINGS_STORAGE_KEY = "tinymist-preview-settings-v1";

export const PREVIEW_FALLBACK_SETTINGS = {
    initialZoom: 1,
} as const;
